// ─── NAV SCROLL STATE ────────────────────────────────────────
(function () {
  const nav = document.getElementById('nav');
  if (nav) {
    window.addEventListener('scroll', function () {
      nav.classList.toggle('scrolled', window.scrollY > 40);
    });
  }
})();

// ─── REVEAL ON SCROLL ────────────────────────────────────────
(function () {
  const reveals = document.querySelectorAll('.reveal');
  if (!reveals.length) return;

  const observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('visible');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.12 });

  reveals.forEach(function (el) { observer.observe(el); });

  // Hero elements reveal immediately
  document.querySelectorAll('.hero .reveal').forEach(function (el) {
    setTimeout(function () { el.classList.add('visible'); }, 200);
  });
})();

// ─── PILLAR TABS ─────────────────────────────────────────────
(function () {
  const tabs = document.querySelectorAll('.pillar-tab');
  if (!tabs.length) return;

  tabs.forEach(function (tab) {
    tab.addEventListener('click', function () {
      const target = tab.dataset.tab;
      document.querySelectorAll('.pillar-tab').forEach(function (t) {
        t.classList.remove('active');
        t.setAttribute('aria-selected', 'false');
      });
      document.querySelectorAll('.pillar-panel').forEach(function (p) {
        p.classList.remove('active');
      });
      tab.classList.add('active');
      tab.setAttribute('aria-selected', 'true');
      const panel = document.querySelector('.pillar-panel[data-panel="' + target + '"]');
      if (panel) panel.classList.add('active');
    });
  });
})();

// ─── KEY MESSAGES CAROUSEL ───────────────────────────────────
(function () {
  const track = document.getElementById('km-track');
  const dots = document.querySelectorAll('.km-dot');
  const prevBtn = document.getElementById('km-prev');
  const nextBtn = document.getElementById('km-next');
  if (!track || !dots.length) return;

  let current = 0;
  const total = dots.length;

  function goTo(n) {
    current = (n + total) % total;
    track.style.transform = 'translateX(-' + (current * 100) + '%)';
    dots.forEach(function (d, i) {
      d.classList.toggle('active', i === current);
    });
  }

  if (prevBtn) prevBtn.addEventListener('click', function () { goTo(current - 1); });
  if (nextBtn) nextBtn.addEventListener('click', function () { goTo(current + 1); });
  dots.forEach(function (dot, i) {
    dot.addEventListener('click', function () { goTo(i); });
  });
  setInterval(function () { goTo(current + 1); }, 8000);
})();

// ─── LIGHTBOX ────────────────────────────────────────────────
(function () {
  const lb = document.getElementById('lightbox');
  const lbImg = document.getElementById('lightbox-img');
  if (!lb || !lbImg) return;

  document.querySelectorAll('.pillar-panel-screenshot img').forEach(function (img) {
    img.style.cursor = 'zoom-in';
    img.addEventListener('click', function () {
      lbImg.src = img.src;
      lbImg.alt = img.alt;
      lb.classList.add('open');
    });
  });

  lb.addEventListener('click', function (e) {
    if (e.target === lb || e.target === lbImg) lb.classList.remove('open');
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') lb.classList.remove('open');
  });

  const closeBtn = lb.querySelector('.lightbox-close');
  if (closeBtn) closeBtn.addEventListener('click', function () { lb.classList.remove('open'); });
})();

// ─── URGENCY BAR FILL ────────────────────────────────────────
(function () {
  const fill = document.querySelector('.cta-spots-fill');
  if (!fill) return;
  // Reset to 0 then animate in when visible
  fill.style.width = '0';
  const observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) {
        fill.style.width = '78%';
        observer.unobserve(e.target);
      }
    });
  }, { threshold: 0.5 });
  observer.observe(fill);
})();

// ─── PREORDER FORM ───────────────────────────────────────────
(function () {
  const form = document.getElementById('petal-preorder-form');
  if (!form) return;

  form.addEventListener('submit', function (e) {
    // Shopify contact form submits normally; this is a client-side success flash
    // Remove this listener if using Shopify's native contact form handling
    const btn = form.querySelector('.cta-btn');
    const successMsg = document.getElementById('petal-form-success');
    if (btn) {
      btn.textContent = "You're on the list. ✓";
      btn.style.background = 'var(--mint)';
      btn.style.color = 'var(--black)';
      btn.disabled = true;
    }
    if (successMsg) successMsg.classList.add('visible');
  });
})();
